<template>
  <button class="hamburger-menu-button" @click="emitClickEvent">
    <img src="/assets/images/hamburger.svg" alt="">
  </button>
</template>

<script>
export default {
  name: 'hamburger-button',
  methods: {
    emitClickEvent () {
      this.$emit('click')
    }
  }
}
</script>

<style scoped lang="scss">
.hamburger-menu-button {
  appearance: none;
  outline: none;
  border: none;
  background-color: transparent;
  padding: 0;
  min-width: 24px;
  margin-right: 2.4rem;
  height: 100%;
  cursor: pointer;

  img {
    pointer-events: none;
  }
}
</style>
